import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  SelectChangeEvent,
} from "@mui/material";
import React, { ChangeEvent } from "react";
import { isSuperAdmin } from "../../util/form/form";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";
import { ESSSubQeustionList, ImageData } from "../../redux/inspection/state";
import styles from "./inspectionDetal.module.css";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import { ButtonTextGrid } from "../..";

interface Props {
  handleChangeParentQuestionId: (event: SelectChangeEvent) => void;
  handleChangeCleaningPhoto: (
    event: ChangeEvent<HTMLInputElement>,
    sub_question: ESSSubQeustionList,
    isFurtherAction: boolean,
  ) => void;
  handleMouseUp: (index: number) => void;
  rotation: number[];
  handleImageClick: (index: number) => void;
  handleDeleteImage: (inspection: ImageData) => void;
}

export default function InspectionPhoto(props: Props) {
  const { user } = useSelector((state: IRootState) => state.userAuth);
  const isSuperAdminRole = isSuperAdmin(user?.token?.role_id as number);
  const {
    selectedInspectionItem,
    questionList,

    selected_sub_question_List,
  } = useSelector((state: IRootState) => state.inspectionState);

  function GenerateInspectionDetail() {
    const inspectionImages = (
      selectedInspectionItem?.imageArray as ImageData[]
    ).filter((img) => (img.is_further_action || 0) === 0);
 

    return (
      <Grid
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 30,
          flexWrap: "wrap",
        }}
      >
        {inspectionImages.length > 0 ? (
          inspectionImages.map((inspection) => (
            <Grid
              key={`group-${inspection.answer_id}`}
              style={{
                display: inspection.answer_id == 0 ? "none" : "flex",
                flexDirection: "column",
                gap: 30,
                marginBottom: 40,
                alignSelf: "flex-start",
              }}
            >
              <Grid
                style={{
                  fontSize: 24,
                  marginTop: 0,
                  marginBottom: 0,
                  fontWeight: "bold",
                  minHeight: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {`${inspection.parent_question}-${inspection.sub_question}`}
              </Grid>
              <div className={styles.imageRowContainer}>
                <div
                  key={`image-${inspection.inspection_response_id}-${inspection.inspection_image_id}`}
                  className={styles.imageItemContainer}
                >
                  <div onClick={() => props.handleMouseUp(inspection.inspection_response_id)}>
                    <img
                      src={`${process.env.REACT_APP_S3}${inspection.image_thumb}`}
                      alt=""
                      style={{
                        margin: 0,
                        padding: 0,
                        display: "block",
                        maxHeight: "300px",
                        width: "auto",
                        height: "auto",
                        transform: `rotate(${props.rotation[inspection.inspection_response_id] || 0}deg)`,
                      }}
                    />
                  </div>
                </div>

                <div
                  className={styles.ButtonContainer}
                  onClick={() => props.handleImageClick(inspection.inspection_response_id)}
                >
                  <Button variant="contained">
                    <ButtonTextGrid>
                      <RotateRightIcon />
                      <Grid>右轉45度</Grid>
                    </ButtonTextGrid>
                  </Button>
                </div>

                <div
                  className={styles.ButtonContainer}
                  onClick={() => props.handleDeleteImage(inspection)}
                >
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "red" }}
                  >
                    <RotateRightIcon />
                    <Grid>刪除圖片</Grid>
                  </Button>
                </div>

       
              </div>
            </Grid>
          ))
        ) : (
          <Grid style={{ padding: 20, textAlign: "center" }}>
            <Typography>沒有檢查時的照片</Typography>
          </Grid>
        )}
      </Grid>


    );
  }

  return (
    <Grid>
      {isSuperAdminRole && (
        <Grid
          style={{
            display: "flex",
            gap: 30,
            flexDirection: "row",
            marginBottom: 30,
            flexWrap: "wrap",
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">檢查項目</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={questionList[0].parent_question_id.toString()}
              label="檢查項目"
              onChange={props.handleChangeParentQuestionId}
            >
              {questionList &&
                questionList.map((question) => (
                  <MenuItem
                    key={`questionList-${question.parent_question_id}`}
                    value={question.parent_question_id}
                  >
                    {question.parent_question}
                  </MenuItem>
                ))}
            </Select>

            <Grid
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                gap: 30,
                margin: 20,
              }}
            >
              {selected_sub_question_List &&
                selected_sub_question_List.map((question) => (
                  <Grid key={`inspection-${question.sub_question_id}`}>
                    <input
                      accept="image/*"
                      id={`inspection-${question.sub_question_id}`}
                      type="file"
                      style={{ display: "none" }}
                      onChange={(e) =>
                        props.handleChangeCleaningPhoto(e, question, false)
                      }
                    />
                    <label htmlFor={`inspection-${question.sub_question_id}`}>
                      <Button variant="contained" component="span">
                        <ButtonTextGrid>
                          添加 {question.sub_question} 相片
                        </ButtonTextGrid>
                      </Button>
                    </label>
                  </Grid>
                ))}
            </Grid>
          </FormControl>
        </Grid>
      )}

      {selectedInspectionItem?.imageArray &&
      selectedInspectionItem.imageArray.length > 0 ? (
        GenerateInspectionDetail()
      ) : (
        <Grid style={{ padding: 20, textAlign: "center" }}>
          <Typography>沒有檢查時的照片</Typography>
        </Grid>
      )}
    </Grid>
  );
}
